/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ClientOfferOut,
    ClientOfferOutFromJSON,
    ClientOfferOutFromJSONTyped,
    ClientOfferOutToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientOfferOutList
 */
export interface ClientOfferOutList {
    /**
     * 
     * @type {string}
     * @memberof ClientOfferOutList
     */
    url: string;
    /**
     * 
     * @type {Array<ClientOfferOut>}
     * @memberof ClientOfferOutList
     */
    clientOffers: Array<ClientOfferOut>;
}

export function ClientOfferOutListFromJSON(json: any): ClientOfferOutList {
    return ClientOfferOutListFromJSONTyped(json, false);
}

export function ClientOfferOutListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientOfferOutList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
        'clientOffers': ((json['clientOffers'] as Array<any>).map(ClientOfferOutFromJSON)),
    };
}

export function ClientOfferOutListToJSON(value?: ClientOfferOutList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'clientOffers': ((value.clientOffers as Array<any>).map(ClientOfferOutToJSON)),
    };
}


